export const FORWARD = 'forward'
export const BACKWARD = 'backward'
export const LEFT = 'left'
export const RIGHT = 'right'
export const ROTATE_LEFT = 'rot_left'
export const ROTATE_RIGHT = 'rot_right'
export const STOP = 'stop'
export const START_CHARGING = 'start_charging'
export const STOP_CHARGING = 'stop_charging'
export const SET_POWER_LOW = 'set_power_low'
export const SET_POWER_MEDIUM_LOW = 'set_power_medium_low'
export const SET_POWER_MEDIUM = 'set_power_medium'
export const SET_POWER_HIGH = 'set_power_high'
export const TILT_CAMERA_UP = 'tilt_camera_up'
export const TILT_CAMERA_DOWN = 'tilt_camera_down'
export const TILT_CAMERA_STOP = 'tilt_camera_stop'
